import Nullstack from 'nullstack';
export default function IconHomeEco({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-home-eco",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20.002 11.002l-8.002 -8.002l-9 9h2v7a2 2 0 0 0 2 2h5"
  }), "   ", Nullstack.element("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.325 0 .631 .077 .902 .215"
  }), "   ", Nullstack.element("path", {
    d: "M16 22s0 -2 3 -4"
  }), "   ", Nullstack.element("path", {
    d: "M19 21a3 3 0 0 1 0 -6h3v3a3 3 0 0 1 -3 3z"
  }), " ");
}